import { render, staticRenderFns } from "./asset-type-checklists.vue?vue&type=template&id=2468d664&scoped=true&"
import script from "./asset-type-checklists.vue?vue&type=script&lang=js&"
export * from "./asset-type-checklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468d664",
  null
  
)

export default component.exports